import useSWR from 'swr';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type { Seats } from '@/types/admin-settings';

const CACHE_KEY = 'admin-members-seats';

export function useSeats() {
    const { data, isLoading, mutate } = useSWR<Seats>(
        CACHE_KEY,
        () => AdminSettingsService.getSeats(),
        { revalidateOnFocus: false },
    );

    return {
        current: data?.current ?? 0,
        max: data?.max,
        isLoading,
        mutate,
    };
}
